import { clientManagementAction } from './actions';

import {
    CLIENT_DETAILS_REQUEST_FAIL,
    CLIENT_DETAILS_REQUEST_SUCCESS,
    CLIENT_DETAILS_REQUEST_START,
    VBAN_DETAILS_REQUEST_SUCCESS,
    VBAN_DETAILS_REQUEST_FAIL,
    VBAN_DETAILS_REQUEST_START
} from './types';

export interface ClientDetails {
    id: string,
    name: string,
    clientId: string,
    clientReferenceId: string,
    country: string
};

export interface VBANDetails {
    bankName: string,
    ibanAccountNumber: string,
    wireRoutingNumber: string,
    achRoutingNumber: string,
    accountType: string,
    currency: string,
    accountStatus: string
}

type ResourcesState = {
    clientDetailsLoadingState: string,
    vbanDetailsLoadingState: string,
    clientDetailsResult: ClientDetails[],
    vbanDetailsResult: VBANDetails | null
};

const rowsData = [
    {
        id: '1',
        country: 'england',
        name: 'Gemma Huckle',
        clientId: '0301000004485005',
        clientReferenceId: '12349965'
    },
    {
        id: '2',
        country: 'canada',
        name: 'Daniel Beckham',
        clientId: '0301000004485006',
        clientReferenceId: '12349966'
    },
    {
        id: '3',
        country: 'spain',
        name: 'Cody Fisher',
        clientId: '0301000004485007',
        clientReferenceId: '12349967'
    },
    {
        id: '4',
        country: 'germany',
        name: 'Trent Wilson',
        clientId: '0301000004485008',
        clientReferenceId: '12349968'
    },
    {
        id: '5',
        country: 'india',
        name: 'Trent Wilson',
        clientId: '0301000004485009',
        clientReferenceId: '12349969'
    },
    {
        id: '6',
        country: 'albania',
        name: 'John Doe',
        clientId: '0301000004485004',
        clientReferenceId: '12349964'
    },
    {
        id: '7',
        country: 'england',
        name: 'Gemma Huckle',
        clientId: '0301000004485005',
        clientReferenceId: '12349965'
    },
    {
        id: '8',
        country: 'canada',
        name: 'Daniel Beckham',
        clientId: '0301000004485006',
        clientReferenceId: '12349966'
    },
    {
        id: '9',
        country: 'spain',
        name: 'Cody Fisher',
        clientId: '0301000004485007',
        clientReferenceId: '12349967'
    },
    {
        id: '10',
        country: 'germany',
        name: 'Trent Wilson',
        clientId: '0301000004485008',
        clientReferenceId: '12349968'
    },
    {
        id: '11',
        country: 'india',
        name: 'Trent Wilson',
        clientId: '0301000004485009',
        clientReferenceId: '12349969'
    },
    {
        id: '12',
        country: 'albania',
        name: 'John Doe',
        clientId: '0301000004485004',
        clientReferenceId: '12349964'
    }
];

const INITIAL_STATE: ResourcesState = {
    clientDetailsLoadingState: 'UNINITIALISED',
    vbanDetailsLoadingState: 'UNINITIALISED',
    clientDetailsResult: [],
    vbanDetailsResult: {
        bankName: '',
        ibanAccountNumber: '',
        wireRoutingNumber: '',
        achRoutingNumber: '',
        accountType: '',
        currency: '',
        accountStatus: ''
    }
};

export const reducer = (
    state: ResourcesState = INITIAL_STATE,
    action: clientManagementAction
): ResourcesState => {
    switch (action.type) {

        case CLIENT_DETAILS_REQUEST_START:
            return {
                ...state,
                clientDetailsLoadingState: 'LOADING'
            };

        case CLIENT_DETAILS_REQUEST_SUCCESS:
            return {
                ...state,
                clientDetailsLoadingState: 'LOADED',
                clientDetailsResult: action.payload
            };

        case CLIENT_DETAILS_REQUEST_FAIL:
            return {
                ...state,
                clientDetailsLoadingState: 'ERROR',
                clientDetailsResult: []
            };

        case VBAN_DETAILS_REQUEST_START:
            return {
                ...state,
                vbanDetailsLoadingState: 'LOADING'
            };

        case VBAN_DETAILS_REQUEST_SUCCESS:
            return {
                ...state,
                vbanDetailsLoadingState: 'LOADED',
                vbanDetailsResult: action.payload
            };

        case VBAN_DETAILS_REQUEST_FAIL:
            return {
                ...state,
                vbanDetailsLoadingState: 'ERROR',
                vbanDetailsResult: null
            };

        default:
            return state;
    }
};